import type { ReactNode } from 'react'
import { useId } from 'react'
import styles from './Card.module.css'

export interface CardProps {
  title?: ReactNode
  /** Right side of the header: a link or small caption. */
  action?: ReactNode
  /** `flush` removes body padding (lists / tables). */
  variant?: 'default' | 'flush' | 'navy'
  headingLevel?: 2 | 3
  className?: string
  children?: ReactNode
}

export function Card({ title, action, variant = 'default', headingLevel = 2, className, children }: CardProps) {
  const id = useId()
  const H = headingLevel === 2 ? 'h2' : 'h3'
  return (
    <section className={[styles.card, styles[variant], className ?? ''].join(' ')} aria-labelledby={title ? id : undefined}>
      {(title || action) && (
        <div className={styles.head}>
          {title && <H id={id} className={styles.title}>{title}</H>}
          {action && <div className={styles.action}>{action}</div>}
        </div>
      )}
      <div className={styles.body}>{children}</div>
    </section>
  )
}
